if ( document.querySelector( '#ofh-language-switch-cy' ) ) {

  document.querySelector( '#ofh-language-switch-cy' ).addEventListener( 'click', function( event ) {

    ofh_language_set( 'cy' );

  } );

}

if ( document.querySelector( '#ofh-language-switch-en' ) ) {

  document.querySelector( '#ofh-language-switch-en' ).addEventListener( 'click', function( event ) {

    ofh_language_set( 'en' );

  } );

}
